const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        formTitle: "Sign in to TeamChat",
        welcome: "Hi, Welcome Back",
        details: "Enter your details below.",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
          notUser: "Don't have an account?",
          demo: "Request a demo test!",
        },
      },
      weekDays: {
        title: "Days",
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        avoidHoliday: "Only working day",
      },

      salutation: {
        goodmorning: "Good Morning",
        goodafternoon: "Good Afternoon",
        goodnight: "Good night",
        gooddawn: "Good Morning"
      },
      companyList: {
        cancel: "Cancel",
        edit: "Edit",
        add: "Add",
        emailDefault: "Email Default",
        maxWhatsapp: "MAX Whatsapps",
        maxUsers: "MAX Users",
        cnpj: "CNPJ",
        company: "Company",
        editCompany: "Edit Company",
        addCompany: "Add Company"
      },
      userType: {
        translate: {
          infoReload: "The page will reload whenever you edit the user itself.",
          user: "User",
          admin: "Administrator",
          superUser: "Super User",
          sendPhoto: "Send Photo",
          company: "Company",
          empty: "Empty",
          searchUsers: "Search Users",
          searchContacts: "Search Contacts",
          name: "Name",
          number: "Number",
          email: "Email",
          quotation: "Quotation",
          type: "Type",
          action: "Actions",
          result: "Results",
          page: "From",
          of: "to",
          notifications: 'Notifications',
          resultsPerPage: "Results per Page",
          selectQueue: "Select a team",
          send: "Send",
          errorPermissionNotifications: "You don't have notifications permissions!",
          newMessageUser: "New message from ",
          modifyDefinitionsBot: "Use Teams in List?",
          changeSuccess: "You change to ",
          listSuccess: "list",
          defaultSuccess: "Default",
          openWppWeb: "Open in Whatsapp Web",
          openCall: "Call to Number",
          config: "Theme Options",
          theme: "Theme",
          colors: "Colors",
          notNotifications: "Browser notifications disabled!",
          notUsers: "Add users to have access to the internal chat.",
          sayHello: "Say hello to your new contact!",
          you: "You",
          notQuickAnswers: "Not quick answers",
          hello: "Hello",
          needHelp: "Need help?",
          finish: "Finish",
          finishTicket: "Finish Chat",
          wasResolved: "Was Closed?",
          reason: "Reason for contact",
          yes: "Yes",
          no: "No",
          closed: "Closed",
          photo: "Photo",
          video: "Video",
          audio: "Audio",
          file: 'Archive',
          resolved: 'Closed'
        }
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        tickets: {
          ticketsRealTime: "Report - Real Time",
          ticketsOpen: "Open",
          ticketsPending: "Pending",
          ticketsClosed: "Closed",
        },
        charts: {
          perDay: {
            title: "Chats today",
          },
        },
      },
      companies: {
        pages: {
          companies: 'Companies',
          overview: {
            name: 'Overview',
            companies: 'Companies',
            users: 'Users',
            connections: 'Connections',
            ram: {
              usage: 'RAM usage',
              usageTotal: 'Used'
            },
            system: {
              systemSpec: 'Server specifications',
              storage: 'Storage',
              so: 'Operating System'
            }
          },
          report: 'Report',
        },
        buttons: {
          add: 'Add company',
        },
        deleteInfo: 'By deleting the company, you will lose all registration data and the history of this company and its users.',
        list: {
          companies: 'Companies',
          overview: 'Overview',
          systemReport: 'Usage report'
        },
        table: {
          name: 'Name',
          cnpj: 'Cnpj',
          connections: 'N° Connections',
          users: 'N° Users',
          action: 'Actions'
        },
        confirmations: {
          delete: 'Do you really want to delete the company'
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "Connection deleted sucessfully!",
          copied: "Token copied: "
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          channel: 'Channel',
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          autoClose: "Automatic closing",
          autoCloseTimeOut: "Time limit",
          autoCloseMessage: "Message on closing",
          actions: "Actions",
          session: "Session",
        },
        channel: {
          name: 'Integration channel',
          whatsapp: 'Whatsapp',
          telegram: 'Telegram',
          instagram: 'Instagram',
          messenger: 'Messenger'
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        autoClose: 'Auto Close',
        autoCloseTime: 'Auto Close Time Limit',
        autoCloseMessage: 'Message when AutoClose',
        channel: {
          name: 'Integration channel',
          whatsapp: 'Whatsapp',
          telegram: 'Telegram',
          instagram: 'Instagram',
          messenger: 'Messenger'
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        exportSuccess: "Export contacts successfully",
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          exportTitlte: "Export contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related Chats will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
          exportMessage: "Do you want to export all contacts?",
        },
        buttons: {
          import: "Import Contacts",
          export: "Export Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          quotation: "Quotation",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      ChatbotModal: {
        title: {
          add: "Create chatbot",
          edit: "Edit name",
        },
        form: {
          name: "Name",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Chatbot created successfully.",
      },
      queueModal: {
        title: {
          add: "Add team",
          edit: "Edit team",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
          messageAccepting: "message on accept",
          description: "Description of Team",
          token: "Token",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          options: "Markups",
        },
        markups: {
          queue: "Team",
          userName: "User name",
        }
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Whatsapp"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
        },
        form: {
          name: "Name",
          color: "Color"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Edit",
          cancel: "Cancel",
        },
        success: "Tag Save Success.",
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle:
            "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be reversed.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tagged Records",
          actions: "Actions",
        },
        buttons: {
          add: "Add Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        }
      },
      chat: {
        noTicketMessage: "Select a Chat to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Teams",
      },
      tickets: {
        toasts: {
          deleted: "The Chat you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          pending: { title: "Pending" },
          closed: { title: "Closed" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search Chat and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Chat",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Team",
        fieldQueuePlaceholder: "Select Team",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Pending",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No Chats found with this status or search term.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Chat",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Chats",
          kanban: "Kanban",
          calendar: "Calendar",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Teams",
          administration: "Administration",
          admin: "Admin",
          users: "Users",
          settings: "Settings",
          tags: "Tags",
          company: "Companies",
          report: "General report",
          massMessaging: "Mass Messaging",
          messagesAPI: "API",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      messagesAPI: {
        title: 'API',
        textMessage: {
          number: 'number',
          body: 'body',
          token: 'token',
        },
        mediaMessage: {
          number: 'number',
          body: 'body',
          media: 'media',
          token: 'token',
        }
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Teams",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          messageAccepting: "Message on accept",
          actions: "Actions",
        },
        buttons: {
          add: "Add team",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Chats in this team will still exist, but will not have any teams assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Teams",
      },
      massMessaging: {
        title: "Mass Messaging",
        table: {
          shortcut: "Title of Mass Messaging",
          message: "Message to be sent",
          actions: "Actions",
        },
        buttons: {
          play: 'Play',
          pause: 'Pause',
          edit: 'Edit',
          delete: 'Delete',
        },
        actions: {
          startIn: 'Start In',
          endIn: 'End In',
          intervalStart: 'Interval Start',
          intervalEnd: 'Interval End',
        },
        contacts: "Contacts",
        file: "File",
        edit: "Edit Mass Messaging",
        add: "Create Mass Messaging",
        buttonsOp: {
          add: "Create Mass Messaging",
          example: "Contacts file",
        },
        total: "Total: ",
        success: "Success: ",
        error: "Error: ",
        days: "Estimate: ",
        selectAll: "Select All"
      },
      massMessagings: {
        table: {
          shortcut: "Name",
          message: "Message",
          date: "Start and end date",
          interval: "Interval",
          period: "Period",
          daysOfWeek: "Days Of Week",
          status: "Status",
          progress: "Progress",
          actions: "Actions",
        },
        wpp: {
          name: 'Whatsapp',
          connected: 'Connected',
          disconnect: 'Disconnected'
        },
        buttons: {
          play: 'Play',
          pause: 'Pause',
          edit: 'Edit',
          delete: 'Delete',
        },
        period: {
          from: "From",
          of: "to",
          daytime: "Daytime",
          nocturnal: "Nocturnal"
        },
        status: {
          all: 'All',
          waiting: "Waiting",
          started: "Started",
          finished: "Finished",
          waitingTime: "Waiting for time",
          paused: "Paused",
        },
        toasts: {
          deleted: "Disparo excluída com sucesso.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle:
            "Are you sure you want to delete the message trigger: ",
          deleteMessage: "This action cannot be reversed and you will lose progress if it has already started.",
        },
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      chatbot: {
        title: "Chatbot",
        table: {
          name: "Name",
          updatedAt: "Last update",
          actions: "Actions",
        },
        buttons: {
          add: "Create chatbot",
        },
        toasts: {
          deleted: "Chatbot deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle:
            "Are you sure you want to delete the chatbot: ",
          deleteMessage: "This action cannot be reversed.",
        },
        editFlow: {
          loading: 'Loading flow...',
          save: 'Saving flow...',
          type: {
            saveResponse: 'Save answer',
            conditional: 'Conditional',
            finished: 'End'
          },
          step: {
            start: 'Flow start.',
            save: 'Save answer.',
            conditional: 'Define a question or continuations.',
            endToQueue: 'Ends the flow by transferring to the sector.',
            end: 'Ends the flow by closing the chat.'
          },
          options: {
            edit: 'Edit card.',
            delete: 'Delete card.',
          },
          buttons: {
            save: "Save flow",
            cancel: "Cancel edit",
            addFinish: "Add ending",
            addConditional: "Add conditional",
          },
        },
        menu: {
          options: {
            end: 'Finish',
            conditional: 'Conditional',
            finalizeService: 'End chat',
            saveResponse: 'Save response',
            transferTo: 'Transfer to',
            responseAfterCapture: 'Response after capture',
            endFlow: 'End flow',
            message: 'Message',
            title: 'Title',

          },
          buttons: {
            save: 'Save',
            cancel: 'Cancel'
          }
        }
      },
      reportTickets: {
        title: "Chat Report",
        table: {
          name: "Contact name",
          number: "Contact number",
          createdOn: "Contact date",
          updatedOn: "Last update",
          status: "Current status",
          userAtt: "Assigned User",
          notUserAtt: "No User Assigned",
          actions: "Actions",
        },
        buttons: {
          export: "Export All in Excel",
          filter: "Filter",
          viewTicketMsg: "View conversation of this chat",
        },
        status: {
          open: 'Open',
          pending: 'Pending',
          closed: 'Closed',
          all: 'All'
        },
        excel: {
          error: 'There are no chats to generate a report.',
          archive: 'Report',
          name: 'Name',
          number: 'Number',
          createdAt: 'Contact date',
          updatedAt: 'Date of last interaction',
          status: 'Status',
          protocol: 'Protocol',
          assignedUser: 'Assigned User',
          queue: 'Team',
        },
        searchPlaceholder: "Search...",
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open chats will be moved to team.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          answerInGroups: {
            name: 'Answer in groups',
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolved: "Closed",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Drag and drop files to messages window or / for quick answers",
        placeholderClosed: "Reopen or accept this chat to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete chat #",
          titleFrom: "from contact ",
          message: "Attention! All chat's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      internalChat: {
        selectChat: "Select a user to chat with.",
        emojiPicker: "Emoji",
        messageType: "Message",
        searchUser: "Search user"
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open chat for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No chat found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating chat on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one team.",
        ERR_CONN_TOKEN_EXIST:
          "There is already a connection with this token.",
        ERR_CONN_NAME_EXIST:
          "There is already a connection with this name.",
      },
    },
  },
};

export { messages };
